import styled from 'styled-components';

import {
	SYS_SPACE_FIXED_200,
	SYS_SPACE_FIXED_300,
	SYS_SPACE_FIXED_450,
	SYS_SPACE_FIXED_500,
	SYS_SPACE_RELATIVE_2_XL,
	SYS_SPACE_RELATIVE_3_XL,
} from '@oneaudi/unified-web-alpha-common';
import { customBreakPoint, mobileBreakPoint } from '~/styles/break-points';

export const SelectionStepSectionStyle = styled.section<{ $hide: boolean | undefined }>`
	display: ${(props) => (props.$hide ? 'none' : 'flex')};
	flex-direction: column;
	width: 100%;
	height: max-content;
	padding-bottom: ${SYS_SPACE_RELATIVE_3_XL};

	.gallery-wrapper {
		padding-top: ${SYS_SPACE_FIXED_200};
		display: flex;
		flex-direction: column;
		width: 100%;
		min-width: 0;
		position: relative;
		top: 0;
		z-index: 9;
		height: max-content;
		${customBreakPoint(
			mobileBreakPoint,
			`
			position: sticky;
		`,
		)}
	}

	.step-headline-container {
		& > div:nth-child(1) {
			margin-bottom: ${SYS_SPACE_FIXED_300};
		}
		& > div:nth-child(2) {
			margin-bottom: ${SYS_SPACE_FIXED_300};
		}
	}

	.step-headline-container-desktop {
		display: flex;
		flex-direction: column;
		width: 100%;
		& > div:nth-child(1) {
			margin-bottom: ${SYS_SPACE_FIXED_300};
		}
		& > div:nth-child(2) {
			margin-bottom: ${SYS_SPACE_FIXED_300};
		}
	}

	${customBreakPoint(
		mobileBreakPoint,
		`
			flex-direction: row-reverse;
			gap: ${SYS_SPACE_RELATIVE_2_XL};
		`,
	)}
`;

export const ConfigurationStepStyle = styled.div`
	padding-top: ${SYS_SPACE_FIXED_450};
	max-width: 100%;
	width: 100%;

	.headline-overwrite {
		display: flex;
		flex-direction: column;
		gap: ${SYS_SPACE_FIXED_500};
	}

	${customBreakPoint(
		mobileBreakPoint,
		`
			max-width: 347px;
			min-width: 347px;
		`,
	)}
`;
